import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "services-swiper__card" };
var _hoisted_2 = { class: "services-swiper__card-price" };
var _hoisted_3 = { class: "services-swiper__card-name" };
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import CartIcon from '@/icons/CartIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ServicesSwiper',
    props: {
        services: {
            type: Object,
            required: true
        }
    },
    setup: function (__props) {
        var renderPaginationBullet = function (index, className) {
            return "<span class=\"".concat(className, " services-swiper__pagination-bullet\"></span>");
        };
        var onSlideChange = function (swiper) {
            var bullets = document.querySelectorAll('.services-swiper__pagination-bullet');
            var slidesPerView = swiper.params.slidesPerView;
            var activeIndex = swiper.activeIndex;
            bullets.forEach(function (bullet, index) {
                if (index >= activeIndex && index < activeIndex + slidesPerView) {
                    bullet.classList.add('active');
                }
                else {
                    bullet.classList.remove('active');
                }
            });
        };
        return function (_ctx, _cache) {
            var _component_el_icon = _resolveComponent("el-icon");
            var _component_el_button = _resolveComponent("el-button");
            var _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Swiper), {
                    class: "services-swiper",
                    "slides-per-view": 'auto',
                    "space-between": 15,
                    freeMode: true,
                    pagination: {
                        el: '.services-swiper__pagination',
                        clickable: true,
                        renderBullet: renderPaginationBullet
                    },
                    modules: [_unref(Pagination)],
                    onSlideChange: onSlideChange
                }, {
                    default: _withCtx(function () { return [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.services, function (service) {
                            return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                                class: "services-swiper__slide",
                                key: service.id
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("div", _hoisted_1, [
                                        _createElementVNode("div", {
                                            class: "services-swiper__card-image",
                                            style: _normalizeStyle({ backgroundImage: "url(".concat(service.image, ")") })
                                        }, [
                                            _createVNode(_component_el_button, {
                                                class: "services-swiper__card-button",
                                                circle: ""
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_component_el_icon, { size: 20 }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(CartIcon, { color: '#222222' })
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                _: 1
                                            }),
                                            _createElementVNode("div", _hoisted_2, _toDisplayString(service.price > 0 ? "".concat(service.price, "\u20BD") : 'free'), 1)
                                        ], 4),
                                        _createElementVNode("p", _hoisted_3, _toDisplayString(service.name), 1)
                                    ])
                                ]; }),
                                _: 2
                            }, 1024));
                        }), 128))
                    ]; }),
                    _: 1
                }, 8, ["pagination", "modules"]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "services-swiper__pagination" }, null, -1)),
                _createVNode(_component_router_link, { to: '/market' }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_el_button, {
                            class: "accept-button",
                            color: "#013766",
                            style: { "width": "100% !important" }
                        }, {
                            default: _withCtx(function () { return _cache[0] || (_cache[0] = [
                                _createElementVNode("span", null, "К маркетплейсу", -1)
                            ]); }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                })
            ], 64));
        };
    }
});
